import { useEffect, useState } from 'react';

const MOBILE_POS_QUERY = '(max-width: 1023px)';

export function useIsMobilePos() {
  const [isMobilePos, setIsMobilePos] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(MOBILE_POS_QUERY).matches : false,
  );

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_POS_QUERY);
    const onChange = (e: MediaQueryListEvent) => setIsMobilePos(e.matches);
    mq.addEventListener('change', onChange);
    setIsMobilePos(mq.matches);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isMobilePos;
}
